import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';
import HttpApiCallError from "../errors/HttpApiCallError";

export async function uploadAssignmentFile(files) {
    let data = new FormData();
    data.append('file_upload', files['file']);
    data.append('assignment', files['assignment']);
    data.append('assignment_updated', files['assignment_updated']);

    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignment_files`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "POST";
    baseRequestConfig.body = (data);

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function removeAssignmentFile(fileId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignment_files/${fileId}`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "DELETE";

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function downloadAssignmentFile(fileId, fileSize) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignment_files/${fileId}/download`;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "GET";
    baseRequestConfig.headers['content-type'] = 'application/octet-stream';
    baseRequestConfig.headers['Range'] = 'bytes=0-'+fileSize;

    const response = await asyncFetch(url, baseRequestConfig);

    const blob = await response.blob();

    if (fileSize !== blob.size || response.status === 204) {
        const data = {error: {message:''}};

        data.error.message = fileSize !== blob.size ? 'Incorrect file size.' : data.error.message;
        data.error.message = response.status === 204 ? 'No Content' : data.error.message;

        throw new HttpApiCallError(
            data,
            data.error,
            response.status
        );
    }

    return blob;
}


/** WEBPACK FOOTER **
 ** ./src/connectivity/api.assignment_files.js
 **/